import { SxProps, Theme } from "@mui/material";

const commonStyles = {
  container: {
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: "5mm",
    width: "95mm",
  },

  table: {
    width: "60mm",
  },

  title: {
    mb: "5mm",
    wordBreak: "keep-all",
  },

  image: {
    width: "30mm",
    mt: "15mm",
    objectFit: "contain",
    objectPosition: "center",
  },
};

export default (theme: Theme): Record<string, Record<string, SxProps<Theme>>> => ({
  Outprint: {
    container: {
      display: "none",
      displayPrint: "block",
      marginY: 0,
      padding: "5mm",
      background: "white",
    },

    logo: {
      displayPrint: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "20mm",
      margin: 0,
      padding: 0,
      background: "var(--color-black)",
      img: {
        height: "7.5mm",
      },
      figcaption: {
        display: "none",
      },
    },

    content: {
      mt: "5mm",
      paddingX: 0,
      backgroundColor: "white",
    },

    header: {
      mb: "5mm",
      pb: "5mm",
      borderBottom: "0.5pt solid var(--color-border)",
    },

    title: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      mb: "5mm",
    },

    technical: {
      flexDirection: "row",
      justifyContent: "space-between",
      gap: "2.5mm",
      mb: "5mm",
      pb: "5mm",
      borderBottom: "0.5pt solid var(--color-border)",
    },
  },

  Row: {
    container: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      p: "0.5mm 0",
      borderBottom: "0.5pt solid var(--color-border)",
      span: {
        fontSize: "8pt",
        "&:first-of-type": {
          fontWeight: 500,
        },
      },
    },

    legend: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: "12pt",
      height: "12pt",
      ml: "1pt",
      fontSize: "8pt",
      lineHeight: "12pt",
      color: "var(--color-white)",
      background: "var(--color-grey)",
      borderRadius: "50%",
    },
  },

  RoadwayInfo: {
    ...commonStyles,
  },

  LuminaireRow: {
    ...commonStyles,
  },

  LuminaireFound: {
    ...commonStyles,

    container: {
      ...commonStyles.container,
      width: "100%",
      mb: "5mm",
    },

    table: {
      ...commonStyles.table,
      width: "95mm",
    },

    images: {
      flexDirection: "row",
      justifyContent: "space-around",
      width: "95mm",
      mt: "15mm",
    },

    image: {
      ...commonStyles.image,
      width: "35mm",
      mt: 0,
    },
  },

  Footer: {
    container: {
      position: "fixed",
      bottom: 0,
      left: 0,
      flexDirection: "column",
      width: "100%",
      minHeight: "15mm",
      p: "2mm 5mm",
      textAlign: "justify",
      backgroundColor: "white",
      borderTop: "1px solid var(--color-border)",
      boxSizing: "border-box",
      strong: {
        fontSize: "7pt",
        fontWeight: 600,
        lineHeight: 1,
      },
      small: {
        mt: "1mm",
        fontSize: "7pt",
        textAlign: "center",
      },
    },
  },
});
